import { useUserStore } from 'src/_store/user.store'
import React, { Activity, useContext, useEffect, useState } from 'react'
import { IOrder } from 'src/_models/order.model'
import { WallyMessaging } from 'src/types/types'
import { cn } from 'src/lib/utils'
import { ChevronDown, ChevronUp, Info, InfoIcon, XCircle, XIcon } from 'lucide-react'
import { CometChat, Group } from '@cometchat/chat-sdk-javascript'
import {
  CometChatMessageHeader,
  CometChatMessageList,
  CometChatMessageComposer,
  CometChatGroupMembers,
  CometChatButton
} from '@cometchat/chat-uikit-react'
import { useMutation } from '@tanstack/react-query'
import axios, { AxiosError, AxiosResponse } from 'axios'
import { toast } from 'src/components/ui/use-toast'

const ChatAuction = ({
  order,
  cometChatGroupId,
  toogleChat,
}: {
  order: IOrder
  cometChatGroupId: string
  toogleChat: () => void
}) => {
  const [group, setGroup] = useState<Group>()
  const askRegenForHelpMutation = useMutation({
    mutationFn: async ({ orderId }: { orderId: number }) => {
      const token = localStorage.getItem('token')
      return axios.post(
        `/api/ask-regen-for-help/${order.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      ) as Promise<AxiosResponse<{ message: string }>>
    },
  })

  const [showGroupDetailsModal, setShowGroupDetailsModal] = useState<boolean>(false)

  const customAuxiliaryButtonView = () => {
    return (
      <div className='flex gap-2'>
        <InfoIcon className='cursor-pointer' onClick={() => setShowGroupDetailsModal(true)} />
        <XCircle className='cursor-pointer' onClick={() => toogleChat()} />
      </div>
    );
  }

  const getHeaderViewGroupMembers = () => {
    return (
        <div className="flex justify-between items-center px-4 py-2">
            <div className="cometchat-list-item__body-title">
                Group Members
            </div>
            <XCircle className='cursor-pointer' onClick={() => setShowGroupDetailsModal(false)} />
        </div>
    );
  };

  useEffect(() => {
    CometChat.getGroup(cometChatGroupId).then((groupLocal) => {
      setGroup(groupLocal)
    })
  }, [])

  return (
    <>
      <div
        style={{ boxShadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);' }}
        className={cn(
          'border-primary fixed top-0 -right-[calc(50vw-370.5px)] mr-4 z-50 bg-white rounded-[20px] w-[440px] border-[3.1px] h-[434px] overflow-hidden',
          // minimised && 'h-20',
        )}
      >
          {group && (
            <div className='relative'>
              <Activity mode={!showGroupDetailsModal ? 'hidden' : 'visible'}>
                <div className='absolute top-0 right-0 z-50 w-full bg-white h-[430px]'>
                  <div style={{ height: 'calc(100% - 100px)' }}>
                    <CometChatGroupMembers  group={group} headerView={getHeaderViewGroupMembers()} />
                  </div>
                  <div className="flex w-full justify-center pt-4">
                    <CometChatButton
                      isLoading={askRegenForHelpMutation.isPending}
                      onClick={() => {
                        askRegenForHelpMutation.mutate(
                          { orderId: order.id },
                          {
                            onSuccess: async (resp) => {
                              toast({ title: resp.data.message })
                            },
                            onError: (err) => {
                              const axiosError = err as AxiosError<{ message: string }>
                              toast({ title: axiosError.response?.data.message ?? 'Something went wrong', variant: 'destructive' })
                            },
                          },
                        )
                      }}
                      text='Ask REgen for help'
                    />
                  </div>
                </div>
              </Activity>
              {/* <Activity mode={showGroupDetailsModal ? 'hidden' : 'visible'}> */}
                <CometChatMessageHeader group={group} hideVideoCallButton={true} hideVoiceCallButton={true} auxiliaryButtonView={customAuxiliaryButtonView()} />
                  <div className='h-[274px] min-w-full overflow-y-auto hide-scroll'>
                    <CometChatMessageList
                      group={group}
                      // messagesStyle={messagesStyle}
                      // messageHeaderConfiguration={messageHeaderConfiguration}
                      // detailsConfiguration={detailsConfiguration}
                      // messageComposerConfiguration={messageComposerConfiguration}
                      // messageListConfiguration={messageListConfiguration}
                    />
                  </div>
                  <CometChatMessageComposer 
                  group={group} hideVideoAttachmentOption hideAudioAttachmentOption hideVoiceRecordingButton />
              {/* </Activity> */}

            </div>
            
          )}
      </div>
    </>
  )
}

export default ChatAuction
